import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs';
import { ModalSize } from '../../models/modal-size.model';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'hazmatsuite-next-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent {
  @Input() title = '';
  @Input() cancelButtonLabel = '';
  @Input() confirmButtonLabel = '';
  @Input() showModal = false;
  @Input() hideButtons = false;
  @Input() hideCancelButton = false;
  @Input() modalSize: ModalSize = 'lg';

  @Output() closeModal = new EventEmitter();
  @Output() confirm = new EventEmitter();

  layoutTranslations$ = this.languageService.translations$.pipe(map(data => data['LayoutResource']));

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['LayoutResource']);
  }
}
